import React, { PropsWithChildren } from 'react';
import { View } from 'react-native';

import { scale as initialScale } from '@components/frame';

import type { ScaleFontProps } from '@components/search/operations/components/StartJobPopup/types';

interface HeaderColumnProps extends Pick<ScaleFontProps, 'scale'>, PropsWithChildren {}

// Centres the equal-height rows so the gaps between them stay even (space-between would spread them to the tile edges).
const HeaderColumn = ({ children, scale = initialScale }: HeaderColumnProps) => (
  <View style={{ flex: 1, justifyContent: 'center', paddingRight: scale(8) }}>{children}</View>
);

export default HeaderColumn;
